export default __webpack_public_path__ + "img/daRjUwVE.175a3ef6.svg";